export function validateNumber(number: string): number {
  const numberParsed: number = Number(number);
  return numberParsed >= 0 ? numberParsed : 1;
}
